import draftToHtml from 'draftjs-to-html';
import parse from 'html-react-parser';
import React from 'react';

export const GuidLines = ({ handleClick, GuidLines }) => {
  return (
    <div className='d-flex flex-column gap-2' style={{ maxHeight: '70vh', overflow: 'scroll' }}>
      <div className='title text-align-center'>GUIDELINES</div>
      {/* <ol className='guildlines'>
        <li>
          The clock has been set at the server and the countdown timer at the top right corner of
          your screen will display the time remaining for you to complete the examination. When the
          clock runs out, the examination ends by default - you are not required to end or submit
          your examination at that time
        </li>
        <li>Only 1 question will be displayed on the Test window at a time</li>
        <li>
          When you marked an answer it can&apos;t be changed, So please be careful to choose the
          answer
        </li>
        <li>
          For navigating to another Question Click on the next button at the bottom right of your
          screen, and the button will be active when you choose an option for current question
        </li>
        <li>When you click back button at any question the mock test can&apos;t saved</li>
      </ol> */}
      {parse(draftToHtml(GuidLines), {
        decodeEntities: false,
      })}
      <div
        className='attendmockbtn mockbtnlbl'
        style={{
          backgroundColor: '#02748e',
          color: '#fff',
          alignSelf: 'center',
          height: '30px',
          padding: '10px',
        }}
        onClick={() => {
          handleClick();
        }}
      >
        {' '}
        Start Test
      </div>
    </div>
  );
};
